<template>
  <div class="w-1200 container">
    <div class="top-box">
      <div>
        <el-form ref="form" :model="form" label-width="80px">
          <el-row>
            <el-col :span="8">
              <el-form-item label="CAS" prop="cas">
                <el-input v-model="form.cas_no" placeholder="请输入CAS号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6" :offset="9" class="flex-end">
              <gradient-button background="#0C60E6" @hit="handleSearch">搜索</gradient-button>
              <gradient-button @hit="handleReset" color="#5F616C" border="1px solid #5F616C" background="transparent">
                刷新
              </gradient-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <div class="content-box">
      <div class="ter-bars">
        <div class="left-title">
          <div v-for="item in terbars" :key="item.value" :class="[
            'ter-bar-item',
            activeTarBar === item.value ? 'active' : '',
          ]" @click="handleTarBar(item.value)">
            {{ item.label }}
          </div>
        </div>
        <div class="right-add">
          <gradient-button background="#0C60E6" @hit="handleAdd">新增</gradient-button>
        </div>
      </div>
      <div class="table-box">
        <el-table v-loading="loading" :header-cell-style="{ backgroundColor: '#F6F6F8', color: '#00112B' }"
                  :data="tableData" style="width: 100%">
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column prop="id" label="id" width="100"></el-table-column>
          <el-table-column prop="cas_no" label="CAS" width="150"/>
          <el-table-column prop="product_name" label="产品名称" v-if="activeTarBar != 2"></el-table-column>
          <!--          <el-table-column prop="order_number" label="起售量" v-if="activeTarBar != 2">-->
          <!--            <template slot-scope="scope">-->
          <!--              <span v-if="scope.row.order_number">{{ scope.row.order_number + scope.row.unit }} </span>-->
          <!--              <el-button v-else @click="handleStart(scope.row)" type="text">设置起售量</el-button>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <el-table-column prop="order_number" label="价格" width="150" v-if="activeTarBar != 2">
            <template slot-scope="scope">
              <el-button @click="handleGetContact(scope.row)" type="text">查看</el-button>
              <el-button @click="handlePrice(scope.row)" type="text">新增</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" v-if="activeTarBar != 2" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.remark || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="product_name" label="产品名称" v-if="activeTarBar == 2"/>
          <el-table-column prop="updated_at" label="发布时间" v-if="activeTarBar == 2"/>
          <el-table-column prop="remark" label="失败原因" v-if="activeTarBar == 2"/>
          <el-table-column prop="updated_at" label="更新时间" v-if="activeTarBar != 2"/>
          <el-table-column label="操作" fixed="right" width="300">
            <template slot-scope="scope">
              <div v-if="activeTarBar == 3">
                <el-button @click="handlePrice(scope.row)" type="text">价格</el-button>
                <el-button @click="handleStart(scope.row)" type="text">起售量</el-button>
                <el-button @click="handleTop(scope.row)" v-if="userInfo.member_type==2&&is_vip" type="text">置顶
                </el-button>
                <!--                 <el-button type="text" @click="handlePerfect(scope.row)">完善材料</el-button>-->
                <el-button type="text" @click="handleRemark(scope.row)">备注</el-button>
                <el-button v-if="scope.row.status == 1" @click="handleDown(scope.row)" type="text">下架</el-button>
              </div>
              <div v-else-if="activeTarBar == 1">
                <el-button @click="handleDown(scope.row)" type="text">再次上架</el-button>
                <el-button @click="handleDelete(scope.row)" type="text">删除</el-button>
              </div>
              <div v-else-if="activeTarBar == 2">
                <el-button @click="handleDelete(scope.row)" type="text">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-box">
          <el-pagination class="float-right" @size-change="handleSizeChange" @current-change="handleCurrentChange"
                         :current-page="page" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" background
                         layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog :close-on-press-escape="false" :close-on-click-modal="false" :modal-append-to-body="false" title="新增"
               :visible.sync="dialogVisible" width="30%" :before-close="handleCancel">
      <el-form :model="addForm" ref="addForm" :rules="rules" label-width="80px">
        <el-form-item label="CAS" prop="cas_nos">
          <el-input type="textarea" rows="10" v-model="addForm.cas_nos"
                    :placeholder="`请输入CAS号，一行一个CAS NO. 例如：\n808118-40-3\n1051375-16-6\n808118-40-3\n1051375-16-6\n808118-40-3\n1051375-16-6\n808118-40-3\n1051375-16-6`"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" plain @click="addGoods">联系客服添加未有产品</el-button>
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="handleConfirm">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 投诉建议 -->
    <add-complaint :dialogFormVisible="dialogFormVisible" @close="dialogFormVisible = false" @success="successFun"/>
    <!-- 价格 -->
    <el-dialog :close-on-press-escape="false" :close-on-click-modal="false" :modal-append-to-body="false" title="价格"
               :visible.sync="priceDialogVisible" width="50%">
      <div class="form-box-perfect">
        <el-form :model="priceForm" label-width="110px" ref="priceForm" :rules="priceRules">
          <!-- <el-form-item label="销售模式">
            <el-radio-group v-model="priceForm.mode_type">
              <el-radio label="正常库存销售" value="1"></el-radio>
              <el-radio label="请库存销售" value="2"></el-radio>
            </el-radio-group>
          </el-form-item> -->
          <el-row>
            <el-col :span="12">
              <el-form-item label="数量" prop="sku.number">
                <el-input-number v-model="priceForm.sku.number" :min="1" label="请输入数量"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="单位" prop="sku.unit">
                <el-select v-model="priceForm.sku.unit" placeholder="请选择单位" @change="handleUnitChange">
                  <el-option v-for="item in unitList" :key="item.id" :label="item.label"
                             :value="item.label"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="含运费价格" prop="sku.total_price">
            <el-input v-model="priceForm.sku.total_price" type="number" placeholder="请输入含运费价格">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item label="纯度" prop="sku.purity">
            <el-input v-model="priceForm.sku.purity" placeholder="请输入纯度">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-row>
            <el-col :span="12">
              <el-form-item label="发票类型" prop="sku.invoice_type">
                <el-radio-group v-model="priceForm.sku.invoice_type">
                  <el-radio :label="1">专票</el-radio>
                  <el-radio :label="2">普票</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="价格有效期" prop="sku.valid_day">
                <el-input v-model="priceForm.sku.valid_day" type="number" placeholder="请输入价格有效期">
                  <template slot="append">天</template>
                </el-input>
                <!-- <el-input-number
                  v-model="priceForm.sku.valid_day"
                  :min="1"
                  :max="10"
                  label="请输入价格有效期"
                ></el-input-number> -->
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handlePriceCancel">取 消</el-button>
        <el-button type="primary" @click="handlePriceConfirm">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 起售量 -->
    <el-dialog :close-on-press-escape="false" :close-on-click-modal="false" :modal-append-to-body="false" title="起售量"
               :visible.sync="startDialogVisible" width="30%">
      <el-form :model="startForm" label-width="80px" ref="startForm" :rules="startRules">
        <el-form-item label="起售量" prop="order_number">
          <el-input-number v-model="startForm.order_number" :min="1" label="请输入起售量"></el-input-number>
        </el-form-item>
        <el-form-item label="单位" prop="unit">
          <el-select v-model="startForm.unit" placeholder="请选择单位">
            <el-option v-for="item in unitList" :key="item.id" :label="item.label" :value="item.label"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleStartCancel">取 消</el-button>
        <el-button type="primary" @click="handleStartConfirm">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 完善材料 -->
    <el-dialog :close-on-press-escape="false" :close-on-click-modal="false" :modal-append-to-body="false"
               title="完善材料"
               :visible.sync="perfectDialogVisible" width="50%" :before-close="handlePerfectCancel">
      <div class="form-box-perfect">
        <el-form :model="perfectForm" label-width="150px" :rules="perfectRules" ref="perfectForm">
          <el-row>
            <el-form-item label="CAS NO">
              <span>{{ selectRow.cas_no }}</span>
            </el-form-item>
            <el-form-item label="产品名称" prop="product_name">
              <el-input v-model="perfectForm.product_name" placeholder="请输入产品名称"></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="分子式" prop="fenzishi">
                <el-input v-model="perfectForm.fenzishi" placeholder="请输入分子式"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="分子量" prop="fenziliang">
                <el-input v-model="perfectForm.fenziliang" placeholder="请输入分子量"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-form-item label="产品图片" prop="image">
              <ImageUpload :value="perfect" :maxCount="1" @change="handleImage"/>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="产品别名" prop="alias_name">
              <el-input v-model="perfectForm.alias_name" placeholder="请输入产品别名"></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="英文名称" prop="name_en">
              <el-input v-model="perfectForm.name_en" placeholder="请输入英文名称"></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="英文别名" prop="alias_name_en">
              <el-input v-model="perfectForm.alias_name_en" placeholder="请输入产品别名"></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="是否为危化产品" prop="is_danger">
              <el-radio-group v-model="perfectForm.is_danger">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="2">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-row>

          <el-row>
            <el-form-item label="安全信息" prop="safe_information">
              <el-input type="textarea" :rows="5" v-model="perfectForm.safe_information"
                        placeholder="请输入安全信息"></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="MSDS" prop="MSDS">
              <el-input type="textarea" :rows="5" v-model="perfectForm.MSDS" placeholder="请输入MSDS"></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="生成用途" prop="usage">
              <el-input type="textarea" :rows="5" v-model="perfectForm.usage" placeholder="请输入用途"></el-input>
            </el-form-item>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <gradient-button background="transparent" color="#5F616C" border="1px solid #5F616C"
                         @hit="handlePerfectCancel">取消
        </gradient-button>
        <gradient-button background="#0C60E6" @hit="handlePerfectConfirm">确定</gradient-button>
      </div>
    </el-dialog>

    <!--  设置备注弹窗  -->
    <el-dialog title="设置备注" :close-on-press-escape="false" :close-on-click-modal="false"
               :modal-append-to-body="false" :visible="remarkDialogVisible" width="600px"
               :before-close="remarkDialogClose">
      <el-form :model="remarkForm" ref="remarkForm" :rules="remarkRule">
        <el-form-item prop="remark" label="备注">
          <el-input type="textarea" :rows="5" v-model="remarkForm.remark" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <gradient-button background="transparent" color="#5F616C" border="1px solid #5F616C" @hit="remarkDialogClose">
          取消
        </gradient-button>
        <gradient-button background="#0C60E6" @hit="remarkDialogConfirm">确定</gradient-button>
      </div>
    </el-dialog>
    <!-- 价格弹窗 -->
    <el-dialog :close-on-press-escape="false" :close-on-click-modal="false" :modal-append-to-body="false"
               title="价格详情"
               :visible.sync="setCpmPriceDialog" :before-close="cpmPriceDialogClose">
      <el-table :data="priceListData">
        <el-table-column type="index" label="序号"></el-table-column>
        <el-table-column prop="number" label="数量">
          <template slot-scope="scope">
            <el-input v-if="scope.row.id == editPriceInfoId" v-model="scope.row.number" placeholder="请输入数量"/>
            <span v-else>{{ scope.row.number }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="unit" label="单位">
          <template slot-scope="scope">
            <el-select v-if="scope.row.id == editPriceInfoId" v-model="scope.row.unit" placeholder="请选择单位">
              <el-option v-for="item in unitList" :key="item.id" :label="item.label" :value="item.label"></el-option>
            </el-select>
            <span v-else>{{ scope.row.unit }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="total_price" label="含运费价格">
          <template slot-scope="scope">
            <el-input v-if="scope.row.id == editPriceInfoId" v-model="scope.row.total_price"
                      placeholder="请输入含运费价格"/>
            <span v-else>{{ scope.row.total_price }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="purity" label="纯度">
          <template slot-scope="scope">
            <el-input v-if="scope.row.id == editPriceInfoId" v-model="scope.row.purity" placeholder="请输入纯度"/>
            <span v-else>{{ scope.row.purity }}%</span>
          </template>
        </el-table-column>
        <el-table-column prop="invoice_type" label="发票类型">
          <template slot-scope="scope">
            <el-select v-if="scope.row.id == editPriceInfoId" v-model="scope.row.invoice_type"
                       placeholder="请选择发票类型">
              <el-option label="专票(13%)" :value="1"/>
              <el-option label="普票" :value="2"/>
            </el-select>
            <span v-else>{{ scope.row.invoice_type == 1 ? '专票(13%)' : '普票' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="valid_day" label="价格有效期">
          <template slot-scope="scope">
            <el-input v-if="scope.row.id == editPriceInfoId" v-model="scope.row.valid_day"
                      placeholder="请输入价格有效期"/>
            <span v-else>{{ scope.row.valid_day }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="150">
          <template slot-scope="scope">
            <el-button size="mini" v-if="scope.row.id === editPriceInfoId" type="success"
                       @click="saveEditedPrice(scope.row)">保存
            </el-button>
            <el-button size="mini" v-else type="primary" @click="editPriceRow(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="deleteQuote(scope.row)">删除</el-button>
          </template>
        </el-table-column>

      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import addComplaint from "@/components/addInfo/add_complaint.vue";
import GradientButton from "@/components/button/gradient-button.vue";
import ImageUpload from "@/components/public/ImageUpload.vue";
import {
  productAdd,
  productList,
  order_product_number,
  product_enable,
  top_product,
  completeProductInfo,
  productDelete,
  price_product,
  product_detail,
  price_product_edit,
  updatePrice,
  delete_price, confirmProductRemark
} from "@/api/modules/user";
import {mapGetters} from "vuex";

export default {
  name: "my-project",

  components: {
    GradientButton,
    ImageUpload,
    addComplaint
  },
  data() {
    return {
      dialogFormVisible: false,
      // 价格列表
      priceListData: [],
      // 价格弹窗
      setCpmPriceDialog: false,
      // 编辑价格信息
      editPriceInfoId: null,
      // 价格列表
      priceList: [],
      perfect: [],
      // 完善材料弹窗
      perfectDialogVisible: false,
      remarkDialogVisible: false, //备注框显示
      remarkForm: {
        remark: ""
      },
      remarkRule: {
        remark: [
          {required: true, message: "请输入备注", trigger: "blur"},
        ]
      },
      // 完善材料表单
      perfectForm: {
        image: "",
        alias_name: "",
        name_en: "",
        alias_name_en: "",
        fenzishi: "",
        fenziliang: "",
        is_danger: "",
        MSDS: "",
        safe_information: "",
        usage: "",
        product_name: "",
      },
      // 完善材料校验
      perfectRules: {
        product_name: [
          {required: true, message: "请输入产品名称", trigger: "blur"},
        ],
        fenzishi: [
          {required: true, message: "请输入分子式", trigger: "blur"},
        ],
        fenziliang: [
          {required: true, message: "请输入分子量", trigger: "blur"},
        ],
        alias_name: [
          {required: true, message: "请输入产品别名", trigger: "blur"},
        ],
        name_en: [
          {required: true, message: "请输入英文名称", trigger: "blur"},
        ],
        alias_name_en: [
          {required: true, message: "请输入英文别名", trigger: "blur"},
        ],
        is_danger: [
          {required: true, message: "请选择是否为危化产品", trigger: "blur"},
        ],
        MSDS: [{required: true, message: "请输入MSDS", trigger: "blur"}],
        safe_information: [
          {required: true, message: "请输入安全信息", trigger: "blur"},
        ],
        usage: [{required: true, message: "请输入用途", trigger: "blur"}],
        image: [{required: true, message: "请上传产品图片", trigger: "blur"}],
      },
      dialogVisible: false,
      priceDialogVisible: false,
      startDialogVisible: false,
      addForm: {
        cas_nos: "",
      },
      rules: {
        cas_nos: [{required: true, message: "请输入CAS号", trigger: "blur"}],
      },
      startForm: {
        order_number: "",
        unit: "",
      },
      startRules: {
        order_number: [
          {required: true, message: "请输入起售量", trigger: "blur"},
        ],
        unit: [{required: true, message: "请选择单位", trigger: "blur"}],
      },
      priceForm: {
        mode_type: 1,
        sku: {
          valid_day: "",
          invoice_type: "",
          purity: "",
          total_price: "",
          unit: "",
          number: "",
        },
      },
      priceRules: {
        mode_type: [
          {required: true, message: "请选择销售模式", trigger: "blur"},
        ],
        "sku.unit": [
          {required: true, message: "请选择单位", trigger: "blur"},
        ],
        "sku.valid_day": [
          {required: true, message: "请输入价格有效期", trigger: "blur"},
        ],
        "sku.invoice_type": [
          {required: true, message: "请选择发票类型", trigger: "blur"},
        ],
        "sku.purity": [
          {required: true, message: "请输入纯度", trigger: "blur"},
        ],
        "sku.total_price": [
          {required: true, message: "请输入含运费价格", trigger: "blur"},
        ],
        "sku.number": [
          {required: true, message: "请输入数量", trigger: "blur"},
        ],
      },
      tableData: [],
      form: {
        cas_no: "",
      },
      activeTarBar: "3",
      terbars: [
        {
          label: "已发布",
          value: "3",
        },
        {
          label: "已下架",
          value: "1",
        },
        {
          label: "发布失败",
          value: "2",
        },
      ],
      activeName: "first",
      page: 1,
      pageSize: 10,
      total: 0,
      selectRow: {},
      loading: false,
    };
  },
  computed: {
    is_check() {
      return this.$store.getters.is_check;
    },
    unitList() {
      return this.$store.state.config.unitList
    },
    ...mapGetters(['is_vip', "userInfo"])
  },
  mounted() {
    this.getList();
  },
  methods: {

    successFun() {
      this.dialogFormVisible = false

    },
    addGoods() {
      this.dialogFormVisible = true
      this.addForm.cas_nos = ''
      // this.$router.push({
      //   path: "/user/message/complaint",
      // });
    },
    // 上传图片完善资料
    handleImage(val) {
      this.perfect = val;
    },
    // 设置价格
    handleGetContact(row) {
      if (row.sort !== 1) {
        this.$message.error({
          message: "请先添加价格",
          duration: 1000,
          offset: 300,
        });
        return
      } else {
        price_product_edit(row.id).then((res) => {
          this.priceListData = res.data.data.sku
          this.setCpmPriceDialog = true;
        });
      }
    },
    // 编辑价格
    editPriceRow(row) {
      this.editPriceInfoId = row.id;
    },
    // 保存编辑后的价格
    saveEditedPrice(row) {
      updatePrice(row.id, {
        unit: row.unit,
        number: row.number,
        total_price: row.total_price,
        purity: row.purity,
        invoice_type: row.invoice_type,
        valid_day: row.valid_day,
      }).then((res) => {
        if (res.data.code == 10000) {
          this.$message.success({
            message: res.data.message,
            duration: 2000,
            offset: 200,
          });
        }
        this.editPriceInfoId = null;
      });
    },
    // 删除价格列表中的价格
    deleteQuote(row) {
      delete_price(row.id).then((res) => {
        if (res.data.code == 10000) {
          this.$message.success({
            message: res.data.message,
            duration: 2000,
            offset: 200,
          });
          this.priceListData = this.priceListData.filter(item => item.id !== row.id);
        }
      });
    },
    // 关闭弹窗
    cpmPriceDialogClose() {
      this.setCpmPriceDialog = false;
    },
    //设置备注
    handleRemark(row) {
      this.remarkDialogVisible = true;
      this.selectRow = row;
      product_detail(this.selectRow.id).then((res) => {
        if (res.data.code == 10000) {
          this.remarkForm = res.data.data;
        }
      });
    },
    // 备注保存
    remarkDialogConfirm() {
      this.$refs.remarkForm.validate(valid => {
        if (valid) {
          confirmProductRemark(this.selectRow.id, this.remarkForm).then((res) => {
            if (res.data.code == 10000) {
              this.$message.success({
                message: res.data.message,
                duration: 2000,
                offset: 200,
              });
              this.remarkDialogVisible = false;
              this.getList();
            } else {
              this.$message.error({
                message: res.data.message,
                duration: 2000,
                offset: 200,
              });
            }
          })
        }
      });
    },
    //备注弹框关闭
    remarkDialogClose() {
      this.remarkDialogVisible = false
    },
    // 完善材料
    handlePerfect(row) {

      this.perfectDialogVisible = true;
      this.selectRow = row;
      product_detail(this.selectRow.id).then((res) => {
        if (res.data.code == 10000) {
          this.perfectForm = res.data.data;
          this.perfect = [res.data.data.image];
        }
      });
    },
    // 完善材料取消
    handlePerfectCancel() {
      this.perfectDialogVisible = false;
      this.$refs.perfectForm.resetFields();
    },
    // 删除
    handleDelete(row) {

      this.selectRow = row;
      this.$confirm("确定删除该产品吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        productDelete(this.selectRow.id).then((res) => {
          if (res.data.code == 10000) {
            this.$message.success({
              message: res.data.message,
              type: "success",
              duration: 2000,
              offset: 100,
            });
            this.getList();
          } else {
            this.$message.error({
              message: res.data.message,
              type: "error",
              duration: 2000,
              offset: 100,
            });
          }
        });
      });
    },
    // 完善材料确认
    handlePerfectConfirm() {
      this.perfectForm.image = this.perfect[0];
      this.$refs.perfectForm.validate((valid) => {
        if (valid) {
          completeProductInfo(this.selectRow.id, this.perfectForm).then(
              (res) => {
                if (res.data.code == 10000) {
                  this.perfectDialogVisible = false;
                  this.$message.success({
                    message: res.data.message,
                    type: "success",
                    duration: 2000,
                    offset: 100,
                  });
                  this.getList();
                  this.$refs.perfectForm.resetFields();
                } else {
                  this.$message.error({
                    message: res.data.message,
                    type: "error",
                    duration: 2000,
                    offset: 100,
                  });
                }
              }
          );
        }
      });
    },
    // 置顶
    handleTop(row) {
      this.selectRow = row;
      let mes =
          row.is_top == 1 ? "确定取消置顶该产品吗？" : "确定置顶该产品吗？";
      this.$confirm(mes, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        top_product(this.selectRow.id).then((res) => {
          if (res.data.code == 10000) {
            this.$message.success({
              message: res.data.message,
              type: "success",
              duration: 2000,
              offset: 100,
            });
            this.getList();
          }
        });
      });
    },
    // 下架
    handleDown(row) {

      this.selectRow = row;
      let mes = row.status == 1 ? "确定下架该产品吗？" : "确定上架该产品吗？";
      this.$confirm(mes, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        product_enable(this.selectRow.id).then((res) => {
          if (res.data.code == 10000) {
            this.$message.success({
              message: res.data.message,
              type: "success",
              duration: 2000,
              offset: 200,
            });
            this.getList();
          } else {
            this.$message.error({
              message: res.data.message,
              type: "error",
              duration: 2000,
              offset: 200,
            });
          }
        });
      });
    },
    // 新增价格
    handlePrice(row) {
      this.priceDialogVisible = true;
      this.selectRow = row;
      // 刷新表单数据
      this.priceForm = {
        mode_type: 1,
        sku: {
          valid_day: "",
          invoice_type: "",
          purity: "",
          total_price: "",
          unit: "",
          number: "",
        },
      };
      this.$nextTick(() => {
        this.$refs.priceForm.resetFields();
      });
    },
    // 单位改变
    handleUnitChange(val) {
      this.priceForm.sku.unit = val;
    },
    // 新增价格取消
    handlePriceCancel() {
      this.priceDialogVisible = false;
    },
    // 新增价格确认
    handlePriceConfirm() {
      this.$refs.priceForm.validate((valid) => {
        if (valid) {
          this.priceForm.sku.valid_day = Number(this.priceForm.sku.valid_day);
          let data = {
            mode_type: this.priceForm.mode_type,
            sku: [this.priceForm.sku],
          };
          price_product(this.selectRow.id, data).then((res) => {
            if (res.data.code == 10000) {
              this.priceDialogVisible = false;
              this.$message.success({
                message: res.data.message,
                type: "success",
                duration: 2000,
                offset: 100,
              });
              this.getList();
            } else {
              this.$message.error({
                message: res.data.message,
                type: "error",
                duration: 2000,
                offset: 100,
              });
            }
          });
        }
      });
    },
    // 新增起售量取消
    handleStartCancel() {
      this.startDialogVisible = false;
    },
    // 新增起售量确认
    handleStartConfirm() {
      this.$refs.startForm.validate((valid) => {
        if (valid) {
          order_product_number(this.selectRow.id, this.startForm).then(
              (res) => {
                if (res.data.code == 10000) {
                  this.startDialogVisible = false;
                  this.$message.success({
                    message: res.data.message,
                    type: "success",
                    duration: 2000,
                    offset: 100,
                  });
                  this.getList();
                  this.$refs.startForm.resetFields();
                }
              }
          );
        }
      });
    },
    // 新增起售量
    handleStart(row) {

      this.startDialogVisible = true;
      this.selectRow = row;
    },
    // 点击分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    // 点击分页
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    // 点击标签
    handleTarBar(value) {
      this.activeTarBar = value;
      this.page = 1;
      this.getList();
    },
    // 新增产品弹窗
    handleAdd() {
      /**
       * 2026-01-10 修改注册流程
       if (this.mixCheckUserAudit()) {
       this.dialogVisible = true;
       }
       */
      if (this.mixCheckUserMobile()) {
        this.dialogVisible = true;
      }
    },
    // 发布产品
    handleConfirm() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          productAdd(this.addForm).then((res) => {
            if (res.data.code == 10000) {
              this.dialogVisible = false;
              this.$alert(res.data.message, '发布结果', {
                confirmButtonText: '确定',
              });
              this.getList();
              this.addForm.cas_nos = ''
              this.form.cas_no = ''
            } else {
              this.$message.error({
                message: res.data.message,
                type: "error",
                duration: 2000,
                offset: 100,
              });
            }
          });
        }
      });
    },
    handleReset() {
      this.form = {
        cas_no: "",
      };
      this.page = 1;
      this.getList();
    },
    handleSearch() {
      this.page = 1;
      this.getList();
    },
    // 获取产品列表
    getList() {
      this.loading = true;
      productList({
        page: this.page,
        limit: this.pageSize,
        state: this.activeTarBar,
        cas_no: this.form.cas_no,
      }).then((res) => {
        this.tableData = res.data.data.data;
        this.total = res.data.data.total;
        this.loading = false;
      });
    },
    // 新增产品弹窗关闭
    handleCancel() {
      this.dialogVisible = false;
      this.addForm.cas_nos = ''
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep .el-select {
  width: 100%;
}

.form-box-perfect {
  padding: 0 80px;
}

::v-deep .el-dialog__header {
  border-bottom: 1px solid #e5e5e5;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 20px;
}

// 弹窗演示
.form-box {
  padding: 40px;
}

.container {
  padding-bottom: 20px;
}

.add-btn {
  background: #1890ff;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #2979f1;
  font-weight: 400;
  font-size: 18px;
  color: #ffffff;
  text-align: center;
}

.top-box {
  background: #ffffff;
  border-radius: 6px 6px 6px 6px;
  padding: 30px;
  box-sizing: border-box;

  ::v-deep .el-form-item {
    margin-bottom: 0;
  }

  ::v-deep .el-date-editor--daterange.el-input,
  .el-date-editor--daterange.el-input__inner,
  .el-date-editor--timerange.el-input,
  .el-date-editor--timerange.el-input__inner {
    width: 15vw;
  }


  .search-btn {
    width: 120px;
    // height: 50px;
    background: #1890ff;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #2979f1;
    font-weight: 400;
    font-size: 18px;
    color: #ffffff;
    text-align: center;
    // line-height: 50px;
  }

  .reset-btn {
    width: 120px;
    // height: 50px;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #5f616c;
    font-weight: 400;
    font-size: 18px;
    color: #5f616c;
    // line-height: 50px;
    text-align: center;
  }
}

.content-box {
  .ter-bars {
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0;

    .left-title {
      line-height: 28px;
      display: flex;
      align-items: center;
      gap: 50px;

      .ter-bar-item {
        font-weight: 400;
        font-size: 18px;
        color: #5f616c;
        border-bottom: 4px solid transparent;
      }

      .active {
        font-weight: bold;
        font-size: 18px;
        color: #00112b;
        border-bottom: 4px solid #1890ff;
      }
    }
  }

  .table-box {
    padding: 20px;
    // margin-top: 20px;
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;

    .pagination-box {
      padding-top: 40px;

      .float-right {
        text-align: right;
      }
    }
  }
}
</style>
